import React from "react";

export const UploadingView = ({uploadingText = 'Uploading...', progressText}) => {
    return (
        <div className="">
            <img src='/images/uploading-arrows-icon.svg' className="tw-animate-spin tw-h-4"/>
            <span className="tw-ml-2 tw-text-sm tw-text-gray-400 tw-text-center">
                {`${uploadingText} ${progressText ?? ''}`}
            </span>
        </div>
    )
}